// object types
export const WALL = 'wall';
export const ROOF = 'roof';
export const GABLE = 'gable';
export const DOOR = 'door';
export const GATE = 'gate';
export const WINDOW = 'window';
export const WALL_LIGHTBAND = 'wall_lightband';
